import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import useSession from "../hooks/useSession";

const ModelDialog = ({ onInteraction, onClose }) => {
  const [session] = useSession();
  const { user, getL10nInstance } = useContext(UserContext)

  const [opportunityCode, setOpportunityCode] = useState(null);
  const [l10n, setL10n] = useState(null)

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [session, user])

  const handleClick = (event) => {
    event.preventDefault();
    onInteraction(opportunityCode);
  }

  return (
    <>
      <div className="fixed inset-x-0 px-4 py-6 inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 transition-opacity" onClick={onClose}>
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="relative bg-white rounded overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full max-h-full p-4">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute right-2 top-2 p-1 hover:bg-vanilla-100 text-graphite-100 text-sm rounded-md"
          >
            X
          </button>

          <h1 className="font-bold text-2xl text-center">
            {l10n && l10n.getString('Assign your opportunity code')}
          </h1>
          <div className="font-normal text-[#68717A] mt-2">
            <p className="mb-2">
              {l10n && l10n.getString('To proceed with project creation, an opportunity code must be assigned.')}
            </p>
          </div>
          <form action="#" onSubmit={(e) => handleClick(e)}>
            <div className="mb-4">
              <label htmlFor="opportunity_code" className="block font-semibold">
                {l10n && l10n.getString('Opportunity code')}
              </label>
              <input
                id="opportunity_code"
                className="block w-full h-12 my-2 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded"
                onChange={(e) => setOpportunityCode(e.target.value)}
                placeholder="ABCDEFG"
                name="opportunity_code"
                required
              />
            </div>
            <div className="w-full flex justify-center">
              <button
                type="submit"
                className="font-semibold text-base h-12 w-[270px] rounded-[25px] bg-[#6A4278] hover:bg-[#854f99] text-white rounded focus:outline-none"
              >
                {l10n && l10n.getString('Assign code & start project')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ModelDialog;
